import { StoreOrderItem } from "./store-order";

export class StoreCart {
    public id: string;
    public tenantId: string;
    public customerId: string;
    public partnerId: string;
    public storeOrderItems: StoreOrderItem[];
}